<template>
  <transition name="fade">
    <v-step
      v-for="(step, index) of tour.steps"
      v-if="tour.currentStep === index"
      id="v-step"
      :key="index"
      :is-first="tour.isFirst"
      :is-last="tour.isLast"
      :labels="tour.labels"
      :next-step="tour.nextStep"
      :previous-step="tour.previousStep"
      :step="step"
      :stop="tour.stop"
    >
      <template v-if="customActions">
        <div slot="actions">
          <div slot="actions">
            <button class="btn btn-primary" hidden @click="tour.previousStep">
              Previous step
            </button>
            <button
              :id="`tour-next-step-${tour.currentStep - 1}`"
              class="btn btn-primary"
              hidden
              @click="tour.nextStep"
            >
              Next step
            </button>
            <button
              :id="`tour-finish-${tour.currentStep - 1}`"
              class="btn btn-primary"
              hidden
              @click="tour.finish"
            >
              Finish
            </button>
          </div>
        </div>
      </template>
    </v-step>
  </transition>
</template>

<script>
export default {
  name: "TourContainer",
  props: ["tour", "name"],
  computed: {
    customActions() {
      if (this.name === "coachNav") {
        return (
          this.tour.currentStep === 1 ||
          this.tour.currentStep === 2 ||
          (this.tour.currentStep === 4 && this.$route.name !== "CoachTeams") ||
          (this.tour.currentStep === 5 &&
            this.$route.name !== "Team Calendar") ||
          (this.tour.currentStep === 6 && this.$route.name !== "Team Email") ||
          (this.tour.currentStep === 7 && this.$route.name !== "Chat") ||
          (this.tour.currentStep === 8 && this.$route.name !== "Payments") ||
          this.tour.currentStep === 9
        );
      } else if (this.name === "coachTeam") {
        return (
          this.tour.currentStep === 4 ||
          this.tour.currentStep === 5 ||
          this.tour.currentStep === 6 ||
          this.tour.currentStep === 7 ||
          this.tour.currentStep === 8 ||
          this.tour.currentStep === 9 ||
          this.tour.currentStep === 10 ||
          this.tour.currentStep === 11 ||
          this.tour.currentStep === 12 ||
          this.tour.currentStep === 14 ||
          this.tour.currentStep === 15 ||
          this.tour.currentStep === 16 ||
          this.tour.currentStep === 17 ||
          this.tour.currentStep === 18 ||
          this.tour.currentStep === 19 ||
          this.tour.currentStep === 20 ||
          this.tour.currentStep === 21 ||
          this.tour.currentStep === 22 ||
          this.tour.currentStep === 23
        );
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped></style>
